import React from "react";

import { put } from "../../util/fetch";
import ListActiveIcon from "jsx:../../assets/svgs/listActiveIcon.svg";
import ListInactiveIcon from "jsx:../../assets/svgs/listInactiveIcon.svg";
import TileActiveIcon from "jsx:../../assets/svgs/tileActiveIcon.svg";
import TileInactiveIcon from "jsx:../../assets/svgs/tileInactiveIcon.svg";
import "./styles.styl";
import "../../styles/vars.styl";

function Theme(props) {
  const isGridActive = props.customer.use_tile_design;
  const [isChecked, setIsChecked] = React.useState(isGridActive);
  const toggleTheme = () => setIsChecked(!isChecked);
  const [isLoading, setIsLoading] = React.useState(false);

  function handleThemeSwitch() {
    const url = `${location.origin}/api/theme/switch/${props.customer.id}`;
    put(url, {})
      .then(() => {
        props.customer.use_tile_design = !props.customer.use_tile_design;
        props.reloadCatalog();
        setIsLoading(false);
        toggleTheme();
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }

  return (
    <>
      <div className="theme-icons">
        {isGridActive ? (
          <ListInactiveIcon onClick={handleThemeSwitch} aria-label="Is list view" />
        ) : (
          <ListActiveIcon onClick={handleThemeSwitch} aria-label="Switch to list view" />
        )}
        {isGridActive ? (
          <TileActiveIcon onClick={handleThemeSwitch} aria-label="Switch to tile view" />
        ) : (
          <TileInactiveIcon onClick={handleThemeSwitch} aria-label="Is tile view" />
        )}
      </div>
      {isLoading ? "... loading ..." : ""}
    </>
  );
}

export default Theme;
